import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "select2/dist/js/select2.min.js";
import "react-toastify/dist/ReactToastify.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import App from "./App";
import "./index.scss";
import { Provider } from "react-redux";
import store from "./store";
import "./i18n";
import { SocketProvider } from "./context/SocketProvider";
import Language from "./context/Language";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <Provider store={store}>
      <SocketProvider>
        <Language>
          <App />
        </Language>
      </SocketProvider>
    </Provider>
  </>
);
